import { UserType } from "@/app/shared_enums/enums";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../Loader";
import { User } from "@/features/auth/AuthSlice";
import { getLinks } from "@/utils/Helper";

const RemoteUserProtectedRoute = () => {
  const isAuthenticated = Boolean(localStorage.getItem("userToken"));
  const userType = localStorage.getItem("userType") as unknown as UserType;
  const [userInfo, setUserInfo] = useState<User>();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const links = getLinks() || ["/"];

  // Load userInfo from localStorage when the component mounts or when location changes
  useEffect(() => {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      const parsedUserInfo = JSON.parse(userInfoString);
      setUserInfo(parsedUserInfo); // Update state with parsed userInfo
    }
    setIsLoading(false); // Mark loading as complete
  }, [location]); // Re-run this effect when the location changes

  // Show loader while loading
  if (isLoading) {
    return <Loader open={isLoading} />;
  }

  // Redirect admin users trying to access remote user routes to their first available route
  if (userType !== UserType.RemoteUser && isAuthenticated) {
    return <Navigate to={links[0]} />;
  }

  // Redirect to root if not authenticated
  if (!isAuthenticated && location.pathname !== "/") {
    return <Navigate to="/" />;
  }

  // Redirect to root if not authenticated or user persona is not RemoteUser
  if (!isAuthenticated || userType !== UserType.RemoteUser) {
    return <Navigate to="/" />;
  }

  // Redirect to registration if userInfo is missing or has empty name fields
  if (
    isAuthenticated &&
    (!userInfo?.first_name?.trim() || !userInfo?.last_name?.trim()) &&
    location.pathname !== "/user/register-user"
  ) {
    return <Navigate to="/user/register-user" />;
  }

  // If the user is on the registration page but already has valid name fields, redirect to dashboard
  if (
    isAuthenticated &&
    userInfo?.first_name?.trim() &&
    userInfo?.last_name?.trim() &&
    location.pathname === "/user/register-user"
  ) {
    return <Navigate to="/user/home" />;
  }

  // Redirect to dashboard if user tries to access login/OTP pages after being authenticated
  if (
    isAuthenticated &&
    (location.pathname === "/user-login" ||
      location.pathname === "/user-login-otp")
  ) {
    return <Navigate to="/user/home" />;
  }

  // Allow access to the requested route
  return <Outlet />;
};

export default RemoteUserProtectedRoute;
